export const GTM = {
    CODE: 'GTM-52MZ6VG',

    EVENTS: {
        SCREEN_LOAD: 'screen_load',
        GAME_SELECTED: 'game_selected',
        PAGE_VIEW: 'ga_pageLoad',
        CLICKED_PLAY_NOW: 'clicked_play_now',
        CTA_CLICKED: 'cta_clicked',
        PLAYTECH_SETUP_LAUNCHED: 'playtech_setup_launched'
    },

    ACTIONS: {
        CLICKED: 'clicked'
    },

    CATEGORIES: {
        GA_EVENT_CATEGORY: {
            REWARDS_MACHINE: 'rewards_machine',
            CASINO: 'casino',
            SPORTS: 'sports',
            BONUS_SPINS_DETAILS: 'bonus_spins_details'
        }
    },

    LABELS: {
        RM_FIRST_TIME_MODAL: 'rm_first_time_modal'
    }
};
